import { Divider, Stack } from '@mantine/core';
import type { Incident } from '../../../../api';
import { CommentStoreProvider } from '../../../../components/Comment';
import { ErrorBoundary } from '../../../../components/ErrorBoundary';
import IncidentActivity from '../../../../pages/MonitorPage/v2/IncidentDrawer/IncidentActivity';
import IncidentDownstreamResources from '../../../../pages/MonitorPage/v2/IncidentDrawer/IncidentDownstreamResources';
import IncidentMeasurementChart from '../../../../pages/MonitorPage/v2/IncidentDrawer/IncidentMeasurmentChart';
import type { IResourceContentProps } from '../../types';

export function ResourceMonitorIncident({ selected }: IResourceContentProps) {
	const emptyFallback = () => <></>;

	const incident = selected.computedMetadata.incident as Incident | null;

	// Determine the comment to highlight based on metadata
	const highlightedCommentId = (selected.metadata?.comment_id ||
		selected.metadata?.root_id) as string | undefined;

	return (
		<Stack pb="md">
			{incident && <IncidentMeasurementChart incident={incident} />}
			{incident?.target && (
				<>
					<Divider my="md" />
					<ErrorBoundary fallback={emptyFallback}>
						<IncidentDownstreamResources incident={incident} />
					</ErrorBoundary>
				</>
			)}
			<Divider my="md" />
			<CommentStoreProvider>
				{incident && (
					<IncidentActivity
						incident={incident}
						highlightedCommentId={highlightedCommentId}
					/>
				)}
			</CommentStoreProvider>
		</Stack>
	);
}
